import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DynamicComponentFactoryBuilderService {
    private moduleImports: any[];

    constructor() {
        this.moduleImports = [];
    }

    public initialize(moduleImports: any[]): Promise<void> {
        return new Promise((resolve) => {
            this.moduleImports = (this.moduleImports || []).concat(moduleImports);
            resolve();
        });
    }
}